export const APP_SCENE = process.env.REACT_APP_SCENE.toUpperCase();
export const PRIMARY_COLOR = '#031043';
export const SECONDARY_COLOR = '#ee6064';
export const MOBILE_WIDTHS_SIZE = 768;
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');


export const CATEGORY = { QCV: 'QCV', GTNS: 'GTNS', KVC: 'KVC', 'XHNV': 'KVC' };
export const CATEGORY_TITLE = {
  [CATEGORY.QCV]: 'Giải thưởng Khoa học công nghệ Quả Cầu Vàng',
  [CATEGORY.GTNS]: 'Giải thưởng Nữ sinh Khoa học công nghệ Việt Nam',
  [CATEGORY.KVC]: 'Giải thưởng Khuê Văn Các',
}
export const ROLE = {
  CANDIDATE: 'candidate', // Ứng viên/User
  SUPER_ADMIN: 'super_admin', // Quản trị viên (toàn hệ thống: QCV + GTNS + KVC)
  ADMIN_GTNS: 'gtns_admin', // Quản trị viên GTNS
  // Quản trị viên RIÊNG cổng QCV: dùng được các tính năng QCV trên mọi lĩnh vực
  // (duyệt hồ sơ, chấm điểm, cấu hình bảng điểm, xem kết quả bình chọn), KHÔNG
  // đụng tới GTNS/KVC và KHÔNG quản lý người dùng / năm tổ chức.
  // Lưu ý: KHÁC nhóm 'qcv_admin_<lĩnh vực>' (hội đồng chấm 1 lĩnh vực) - các
  // kiểm tra cũ dùng role.includes('qcv_admin_') nên KHÔNG khớp 'qcv_admin'.
  ADMIN_QCV: 'qcv_admin',

  COUNCIL: 'council', // Hội đồng Vote tất cả các cổng
  COUNCIL_QCV: 'council_qcv', // Hội đồng Vote cổng QCV
  COUNCIL_KVC: 'council_kvc', // Hội đồng Vote cổng KVC
  COUNCIL_GTNS: 'council_gtns', // Hội đồng Vote cổng GTNS
}

export const KEYS = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international',

  DAO_TAO: 'daoTao',
  BOI_DUONG: 'boiDuong',

  REWARD: 'reward',
  SOCIAL_ACTIVITY: 'socialActivity',
  PERSONAL_PROCESS: 'personalProcess',
  MAJOR_ACHIEVEMENT: 'majorAchievement',
  OTHER_ACHIEVEMENT: 'otherAchievement',
  PERSONAL_ACHIEVEMENT: 'personalAchievement',

  HTQT: 'htqt',
  HTQG: 'htqg',
  HTCS: 'htcs',
  NCKHCB: 'nckhcb',
  NCKHCT: 'nckhct',
}

export const ACHIEVEMENT_TYPE = {
  REWARD: 'reward',
  SOLUTION: 'solution',
  MONOGRAPH: 'monograph',
  TECH_COMPANY: 'techCompany',
  HR_DEVELOPMENT: 'hrDevelopment',
  RESEARCH_PROJECT: 'researchProject',
  SCIENTIFIC_REPORT: 'scientificReport',
  SCIENTIFIC_RESEARCH: 'scientificResearch',
}

export const ARCHIVEMENT_FORM = {
  [ACHIEVEMENT_TYPE.REWARD]: 'formReward',
  [ACHIEVEMENT_TYPE.SOLUTION]: 'formSolution',
	[ACHIEVEMENT_TYPE.MONOGRAPH]: 'formMonograph',
	[ACHIEVEMENT_TYPE.TECH_COMPANY]: 'formTechCompany',
	[ACHIEVEMENT_TYPE.HR_DEVELOPMENT]: 'formHrDevelopment',
	[ACHIEVEMENT_TYPE.RESEARCH_PROJECT]: 'formResearchProject',
	[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT]: 'formScientificReport',
	[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH]: 'formScientificResearch',
}

// TODO: Chuyển về enums của QCV
export const ARCHIVEMENT_TITLE = {
  [ACHIEVEMENT_TYPE.REWARD]: 'Giải thưởng, huy chương đã đạt được',
  [ACHIEVEMENT_TYPE.SOLUTION]: 'Bằng độc quyền sáng chế, giải pháp hữu ích thuộc lĩnh vực xét thưởng',
  [ACHIEVEMENT_TYPE.MONOGRAPH]: 'Sách chuyên khảo, chương sách',
  [ACHIEVEMENT_TYPE.TECH_COMPANY]: 'Sản phẩm khoa học công nghệ',
  [ACHIEVEMENT_TYPE.RESEARCH_PROJECT]: 'Chương trình, dự án, đề tài nghiên cứu khoa học',
  [ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT]: 'Bài báo khoa học đăng trên hội thảo',
  [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH]: 'Bài báo khoa học đăng trên tạp chí',
  [ACHIEVEMENT_TYPE.HR_DEVELOPMENT + KEYS.DAO_TAO]: 'Đào tạo nhân lực',
  [ACHIEVEMENT_TYPE.HR_DEVELOPMENT + KEYS.BOI_DUONG]: 'Bồi dưỡng nhân lực',
  [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL]: 'Bài báo khoa học đăng trên tạp chí quốc tế',
  [ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC]: 'Bài báo khoa học đăng trên tạp chí trong nước',
}
